
// import { useEffect, useRef, useState } from 'react';
// import Logo from '../../assets/images/Logo.png'
// import BusinessTable from '../../components/BusinessTable/BusinessTable';
// import './BusinessPage.css'
// import AddBusiness from '../../components/AddBusiness/AddBusiness';
// import { Business } from '../../Items/Business';

// import { useDispatch, useSelector } from 'react-redux';
// import { addBusiness, editBusiness, getBusinesses } from '../../Services/BusinessService';

// interface HeaderProps {
//   onOpenNewBusiness: () => void;
//   isAddingBusiness: boolean;
//   isEditingBusiness?: boolean; 
//   onSaveBusiness?: () => void;
// }

// const Header = ({ onOpenNewBusiness, isAddingBusiness,isEditingBusiness,onSaveBusiness  }: HeaderProps) => {
//   return (
//     <header className="header">
//       <section className="logo-section">
//        <img src={Logo} alt="Logo"/>
//       </section>
      
//       <search className="search-wrapper">
//         <input type="search" placeholder="" />
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//           <circle cx="11" cy="11" r="8"></circle>
//           <path d="m21 21-4.35-4.35"></path>
//         </svg>
//       </search>
//    {!isAddingBusiness && (
//         <button className="open-business-btn" onClick={onOpenNewBusiness}>
//           הוסף עסק חדש
//         </button>
        
//       )}
    
// {isAddingBusiness && onSaveBusiness && (
//   <button className="btn purple" onClick={onSaveBusiness}>שמור</button>
// )}
//       <div className="main-link-permission" style={{ marginRight:'2%'}}>
//         {isAddingBusiness ? (isEditingBusiness ? 'עדכון עסק' : 'עסק חדש') : 'עסקים'}
//       </div>
//     </header>
//   );
// };

// const BusinessPage: React.FC = () => {
//   const [openNewBusiness, setOpenNewBusiness] = useState(false);
//   const [editBusinessData, setEditBusinessData] = useState<Business | null>(null);
//   const addBusinessRef = useRef<{ saveBusiness: () => void }>(null);
//   const businesses = useSelector((state:any) => state.Business.businesses); 
//   const dispatch = useDispatch<any>();

//   useEffect(() => {
//     dispatch(getBusinesses()); 
//   }, [dispatch]);

//   const handleSaveBusiness = (business: Business, isEdit: boolean) => {
//     if (isEdit) {
//       dispatch(editBusiness(business.id, business));
//     } else {
//       dispatch(addBusiness(business));
//     }
//     setOpenNewBusiness(false);
//     setEditBusinessData(null);
//   };
  
//   const handleEditBusiness = (business: Business) => {
//     setEditBusinessData(business);
//     setOpenNewBusiness(true);
//   };



//   return (
//     <div className="business-page">
//     <Header   isEditingBusiness={!!editBusinessData} onOpenNewBusiness={() => {setOpenNewBusiness(true); setEditBusinessData(null)}} isAddingBusiness={openNewBusiness}  />
//     {openNewBusiness ? (
//       <AddBusiness ref={addBusinessRef}  onSave={handleSaveBusiness} initialBusiness={editBusinessData} />
//     ) : (
//       <BusinessTable onRowClick={handleEditBusiness}/>
//     )}
//   </div>
//   );
// }

// export default BusinessPage;

import { useEffect, useRef, useState } from 'react';
import Logo from '../../assets/images/Logo.png';
import BusinessTable from '../../components/BusinessTable/BusinessTable';
import './BusinessPage.css';
import AddBusiness, { AddBusinessRef } from '../../components/AddBusiness/AddBusiness';
import { Business } from '../../Items/Business';

import { useDispatch, useSelector } from 'react-redux';
import { addBusiness, editBusiness, getBusinesses } from '../../Services/BusinessService';

interface HeaderProps {
  onOpenNewBusiness: () => void;
  isAddingBusiness: boolean;
  isEditingBusiness?: boolean; 
  onSaveBusiness?: () => void;
  onSearch?: (value: string) => void; // חדש
}


const Header = ({ onOpenNewBusiness, isAddingBusiness, isEditingBusiness, onSaveBusiness,onSearch  }: HeaderProps) => {
  return (
    <header className="header">
      <section className="logo-section">
        <img src={Logo} alt="Logo"/>
      </section>
      {!isAddingBusiness && !isEditingBusiness &&(
        <search className="search-wrapper">
          <input 
            type="search" 
            placeholder="חפש עסק..." 
            onChange={(e) => onSearch?.(e.target.value)} // חיפוש בזמן הקלדה
          />
         {!document.querySelector<HTMLInputElement>(".search-wrapper input")?.value && (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
  )}
        </search>
      )}

      {!isAddingBusiness && (
        <button className="open-business-btn" onClick={onOpenNewBusiness}>
          הוסף עסק חדש
        </button>
      )}

      {isAddingBusiness && onSaveBusiness && (
        <button className="btn-save-business" onClick={onSaveBusiness}>שמור</button>
      )}

      <div className="main-link-permission" style={{ marginRight:'2%'}}>
        {isAddingBusiness ? (isEditingBusiness ? 'עדכון עסק' : 'עסק חדש') : 'עסקים'}
      </div>
    </header>
  );
};

// const BusinessPage: React.FC = () => {
//   const [openNewBusiness, setOpenNewBusiness] = useState(false);
//   const [editBusinessData, setEditBusinessData] = useState<Business | null>(null);
//   const addBusinessRef = useRef<AddBusinessRef>(null);
//   const businesses = useSelector((state:any) => state.Business.businesses); 
//   const dispatch = useDispatch<any>();

//   useEffect(() => {
//     dispatch(getBusinesses()); 
//   }, [dispatch]);

//   const handleSaveBusiness = (business: Business, isEdit: boolean) => {
//     if (isEdit) {
//       dispatch(editBusiness(business.id, business));
//     } else {
//       dispatch(addBusiness(business));
//     }
//     setOpenNewBusiness(false);
//     setEditBusinessData(null);
//   };
  
//   const handleEditBusiness = (business: Business) => {
//     setEditBusinessData(business);
//     setOpenNewBusiness(true);
//   };

//   const handleHeaderSave = () => {
//     addBusinessRef.current?.saveBusiness();
//   };

//   return (
//     <div className="business-page">
//       <Header
//         isEditingBusiness={!!editBusinessData}
//         onOpenNewBusiness={() => { setOpenNewBusiness(true); setEditBusinessData(null); }}
//         isAddingBusiness={openNewBusiness}
//         onSaveBusiness={handleHeaderSave}
//       />

//       {openNewBusiness ? (
//         <AddBusiness ref={addBusinessRef} onSave={handleSaveBusiness} initialBusiness={editBusinessData} />
//       ) : (
//         <BusinessTable onRowClick={handleEditBusiness} />
//       )}
//     </div>
//   );
// }

const BusinessPage: React.FC = () => {
  const [openNewBusiness, setOpenNewBusiness] = useState(false);
  const [editBusinessData, setEditBusinessData] = useState<Business | null>(null);
  const [searchTerm, setSearchTerm] = useState(""); // <-- state חדש לחיפוש
  const addBusinessRef = useRef<AddBusinessRef>(null);
  const businesses = useSelector((state:any) => state.Business.businesses); 
  const dispatch = useDispatch<any>();
 
  // סינון עסקים לפי ערך החיפוש
  const filteredBusinesses = businesses.filter((biz: Business) =>
    Object.values(biz).some(value =>
      value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handleSaveBusiness = (business: Business, isEdit: boolean) => {
    if (isEdit) {
      dispatch(editBusiness(business.id, business));
    } else {
      dispatch(addBusiness(business));
    }
    setOpenNewBusiness(false);
    setEditBusinessData(null);
  };
  
  const handleEditBusiness = (business: Business) => {
    setEditBusinessData(business);
    setOpenNewBusiness(true);
  };

  const handleHeaderSave = () => {
    addBusinessRef.current?.saveBusiness();
  };

  return (
    <div className="business-page">
      <Header
        isEditingBusiness={!!editBusinessData}
        onOpenNewBusiness={() => { setOpenNewBusiness(true); setEditBusinessData(null); }}
        isAddingBusiness={openNewBusiness}
        onSaveBusiness={handleHeaderSave}
        onSearch={setSearchTerm} // נשלח פונקציית חיפוש
      />
      <div className="business-content-container">
        {openNewBusiness ? (
          <AddBusiness ref={addBusinessRef} onSave={handleSaveBusiness} initialBusiness={editBusinessData} />
        ) : (
          <BusinessTable onRowClick={handleEditBusiness} businesses={filteredBusinesses} />
        )}
      </div>
    </div>
  );
}

export default BusinessPage;
